import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AppService, APIStates } from 'src/services/app.service';
import { environment } from 'src/environments/environment';

/**
 * Guard for login route in cashregister mode
 * Ensures configuration exists before allowing login
 */
@Injectable({ providedIn: 'root' })
export class CashRegisterLoginGuard implements CanActivate {
  private appService = inject(AppService);
  private router = inject(Router);

  canActivate(): boolean | UrlTree {
    if (!environment.isCashRegister)
      return true;

    const apiState = this.appService.state;

    if (apiState === APIStates.disconnected || apiState === APIStates.loggedOut) {
      const cashRegisterConfig = localStorage.getItem('cashRegisterConfig');
      if (!cashRegisterConfig)
        return this.router.createUrlTree(['/config']);
    }

    return true;
  }
}
